var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("Select the repair")]),_c('div',{staticClass:"card-table"},_vm._l((_vm.orders),function(order,i){return _c('repair-search-results',{key:i,attrs:{"order":order}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }